/**
 * 游客任务迁移服务
 * 负责迁移游客任务到登录用户
 */
export interface GuestTaskMigrationService {
    /**
     * 迁移游客任务到当前登录用户
     * @returns Promise，迁移完成后resolve
     */
    migrateTasksToUser(): Promise<void>;
}

export const GuestTaskMigrationService = Symbol('GuestTaskMigrationService');
